<template>
  <div>
    <div class="main-content" v-if="loader === 100">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <h3>Configurações do painel pessoal</h3>
                </div>
                <div class="col-md-5">
                  <label>Background</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.background"
                    disabled
                  />
                </div>
                <div class="col-md-5">
                  <label>Cor do card</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.card"
                    disabled
                  />
                </div>
                <div class="col-md-5">
                  <label>Cor do primaria</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.cor_primaria"
                    disabled
                  />
                </div>
                <div class="col-md-5">
                  <label>Cor do secundaria</label>
                  <input
                    type="color"
                    class="form-control"
                    v-model="configuracao.cor_secundaria"
                    disabled
                  />
                </div>
                <div class="form-group col-md-2 d-flex align-items-center">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      v-model="configuracao.degrade"
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitchDegrade"
                      disabled
                  />
                    <label class="custom-control-label" for="customSwitchDegrade"
                      >Degrade</label
                    >
                  </div>
                </div>
                <div class="col-md-12 mb-2">
                  <label>Tempo de contagem regressiva no chamador</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.cooldown"
                      disabled
                    />
                </div>
                <div class="col-md-12 mb-2">
                  <label>Nome dado aos usuários (ex. paciente, pessoa, vítima)</label>
                  <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.tipo_pessoa"
                      disabled
                    />
                </div>
                <div class="col-md-12">
                  <div class="form-group col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.tempo_logout"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch1"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch1">
                        Temporizador de logout (segundos)
                      </label>
                    </div>
                    <input type="number" class="form-control" v-model="configuracao.tempo_logout" v-if="configuracao.tempo_logout" disabled>
                  </div>
                  <div class="form-group col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.painel"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch1"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch1"
                        >Exibir painel</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.cns"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch2"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch2"
                        >Exibir CNS</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-4 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.classifica_risco"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch3"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch3"
                        >Classifica Risco</label
                      >
                    </div>
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.pesquisa"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch4"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch4"
                        >Pesquisa de satisfação</label
                      >
                    </div>
                  </div>
                  <div
                    class="form-group col-md-12 mb-2"
                    v-if="configuracao.pesquisa == 1"
                  >
                    <label>URL</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.link_pesquisa"
                      disabled
                    />
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.integra_ares_triagem"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch5"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch5"
                        >Intrega com Ares Triagem?</label
                      >
                    </div>
                  </div>
                  <div
                    class="form-group col-md-12 mb-1"
                    v-if="configuracao.integra_ares_triagem == 1"
                  >
                    <label>URL</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="configuracao.url_triagem"
                      disabled
                    />
                  </div>
                  <div class="form-group col-md-12 d-flex align-items-center">
                    <div class="custom-control custom-switch">
                      <input
                        v-model="configuracao.imprime_qr"
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch6"
                        disabled
                      />
                      <label class="custom-control-label" for="customSwitch6"
                        >Qr code na impressão?</label
                      >
                    </div>
                  </div>
                  <div class="col-md-12">
                    Link (para apontar a fila local, escreva "local")
                    <input type="text" class="form-control" v-model="configuracao.link_qr" disabled>
                  </div>
                  <div class="col-md-12">
                    <label>Unidade</label>
                    <v-select
                      :options="unidades"
                      :reduce="(unidades) => unidades.id"
                      :label="'nome'"
                      v-model="configuracao.unidade_id"
                      class="vselect"
                      disabled
                    ></v-select>  
                  </div>
                  <div class="col-md-12 mt-2">
                    <div class="block text-right">
                      <router-link to="/configuracoes" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <div class="phone-frame">
                <div class="phone-notch"></div>
                <div
                  class="phone-screen d-flex"
                  :style="
                    'background: ' + (configuracao.degrade ? 'radial-gradient(' + configuracao.background + ', #000000) ' : configuracao.background) + ';'
                  "
                >
                  <div
                    class="card w-100 p-1"
                    :style="
                    'background:' + configuracao.card + ' !important;' +
                    'color:' + configuracao.cor_primaria + ';' +
                    'height: 80%; margin-top: 20%;'
                    "
                  >
                    <b>Fila de senhas (5 {{ configuracao.tipo_pessoa }}s no setor)</b>
                    <h5 :style="'color:' + configuracao.cor_primaria + ';'" class="text-center"><b>Você está na 3º posição </b></h5>
                    <h2 style="border: 1px solid #aaa;">
                      <h2 :style="'color: ' + configuracao.cor_primaria   + '; font-size: '">1º - A0001</h2>
                      <h2 :style="'color: ' + configuracao.cor_primaria   + '; font-size: '">2º - A0002</h2>
                      <h2 :style="'color: ' + configuracao.cor_secundaria + '; font-size: '">3º - A0003</h2>
                      <h2 :style="'color: ' + configuracao.cor_primaria   + '; font-size: '">4º - A0004</h2>
                      <h2 :style="'color: ' + configuracao.cor_primaria   + '; font-size: '">5º - A0005</h2>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      configuracao: {
        tipo_pessoa:          "",
        painel:               0,
        cns:                  0,
        integra_ares_triagem: 0,
        url_triagem:          "",
        envia_ares_triagem:   0,
        background:           '#0001ed',
        card:                 '#ffffff',
        cor_primaria:         '#000000',
        cor_secundaria:       '#cc0000',
        degrade:              1,
        pesquisa:             0,
      },
      unidades: [],
    };
  },
  computed: {},
  methods: {
    getConfiguracao: function (id) {
      const self = this;
      const api = self.$store.state.api + "configuracoes/" + id;

      axios
        .get(api)
        .then((response) => {
          self.configuracao = response.data.data[0];

          self.configuracao.painel    = self.configuracao.painel == "0" ? 0 : 1;
          self.configuracao.cns       = self.configuracao.cns == "0" ? 0 : 1;

          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;

          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getUnidades();

    if (id) {
      self.getConfiguracao(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}
.phone-frame {
  width: 100%;
  height: 550px;
  border: 8px solid black;
  border-radius: 30px;
  background: #f4f4f4;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.phone-notch {
  width: 70%;
  height: 30px;
  background: black;
  border-radius: 20px 20px 0 0;
  position: absolute;
  top: 0;
  z-index: 2;
}

.phone-screen {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.phone-screen p {
  font-size: 1.2rem;
  line-height: 1.5;
  margin: 0;
}

</style>